import { NameRuler } from '@dofleini/validator';

import ElementListView from '@/components/ElementListField/ElementListView';
import MunicipalityMultipleSelect from '@/components/MunicipalityMultipleSelect';
import PhoneEditor from '@/components/PhoneNumberField/PhoneEditor';
import Phones from '@/components/PhoneNumberField/PhonesListView';
import ProvinceSelect from '@/components/ProvinceSelect';
import { useHistorianOfficesPagination } from '@/modules/configuration/containers/HistorianOfficesEntityContainer';
import HistorianOfficesApiService from '@/modules/configuration/services/HistorianOfficesApiService';
import createClearRenderView from '@/utils/createClearRenderView';
import { createRenderRemoteEntity } from '@/utils/createRenderRemoteEntity';
import { createSearchFieldRemote } from '@/utils/createSearchFieldRemote';
import { validations } from '@/utils/fields';
import { renderMunicipality, renderProvince } from '@/utils/location';

export const fields = [
  {
    key: 'name',
    label: 'name',
    required: true,
    rules: [
      NameRuler
    ],
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'address.province',
    required: true,
    label: 'province',
    widget: ProvinceSelect,
    viewWidget: ({ value }) => renderProvince(value)
  },
  {
    key: 'municipalities',
    label: 'municipalities',
    required: true,
    onlyEdit: true,
    related: 'address.province',
    relatedKey: 'province',
    widget: MunicipalityMultipleSelect
  },
  {
    key: 'municipalities',
    required: true,
    onlyView: true,
    colSpan: 1,
    label: 'municipalities',
    viewWidget: ElementListView,
    viewWidgetProps: {
      columns: true,
      customRender: (value) => renderMunicipality(value)
    },
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'address.abstract',
    label: 'address',
    widget: 'textarea',
    widgetProps: { autoSize: { minRows: 2, maxRows: 5 } },
    required: false,
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'phones',
    colSpan: 2,
    required: false,
    label: 'protectedArea.form.phones.placeholder',
    rules: [validations.listPhones(), validations.phoneValidator()],
    widget: PhoneEditor,
    viewWidget: Phones,
    viewWidgetProps: {
      columns: true
    },
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'office',
    colSpan: 2,
    label: 'historian:historianOffices.details',
    required: true,
    renderView: createRenderRemoteEntity({
      service: HistorianOfficesApiService.getOne,
      render: createClearRenderView('name'),
    }),
    widget: createSearchFieldRemote({
      usePagination: useHistorianOfficesPagination,
      fullEntity: true
    }),
    className: 'form-view-mode-vertical-item'
  },
];
